import { render, staticRenderFns } from "./TipoAtividadeView.vue?vue&type=template&id=6d25f00f&"
import script from "./TipoAtividadeView.vue?vue&type=script&lang=js&"
export * from "./TipoAtividadeView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports